import { apiClient } from '@v2/lib';
import type { ConfigurationReadItem } from '@v2/types';

export const configurationsService = {
  /**
   * GET /api/Configurations/ReadUniversalConfigs?PimsId={pimsId}
   *
   * Reads configurations from BOTH ConfigurationUniversals (new) and
   * ConfigurationPimses (legacy) tables, merged and deduplicated by key.
   * This is the correct source of truth for PIMS configurations — the
   * navigation property on GetSpecificPims only reads the legacy table.
   */
  getByPimsId: async (pimsId: string): Promise<ConfigurationReadItem[]> => {
    const response = await apiClient().get<ConfigurationReadItem[]>(
      'Configurations/ReadUniversalConfigs',
      { params: { PimsId: pimsId } },
    );
    return Array.isArray(response.data) ? response.data : [];
  },
};
